import React from 'react';

import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { T } from 'react-translator-component';


const UserProfileButtonLink = () => {
  let user = { id: '' };

  const isUserAuthenticated = useSelector((state: any) => state.user?.isUserAuthenticated);

  if (isUserAuthenticated) {
    user = JSON.parse(localStorage.getItem('auth-user') || '{id: \'\'}');
  }

  return (
    <Link className="option-item click" to={`/user/${user.id}`}>
      {T('View profile')}
    </Link>
  );
};

export default UserProfileButtonLink;